/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    OrderInfoWithOfferInfoDto,
    TagDataDto,
    ValidationResult
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class OrderControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        confirmPaymentForOrder(
                    orderId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/order/orders2/${orderId}/confirmPayment`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        getOrder(
                    orderId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<OrderInfoWithOfferInfoDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/order/orders2/${orderId}`;

            return this._httpClient.get<OrderInfoWithOfferInfoDto>(url, requestOptions);
    }


        lookupBottles(
                    orderId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<Array<TagDataDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/order/orders/${orderId}/bottles/lookup`;

            return this._httpClient.get<Array<TagDataDto>>(url, requestOptions);
    }


        performPaymentForOrder(
                    orderId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/order/orders2/${orderId}/performPayment`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        reserveBottlesForOrder(
                    orderId: number
                , 
                queryParams: {
                    tids: Array<string>,
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/order/orders2/${orderId}/reserveBottles`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        searchOrders(
                
                queryParams: {
                    statuses?: Array<string>,
                    sellerOrgUnitId?: number,
                    sellerUserId?: number,
                    parentOfferId?: number,
                    userLegalEntityId?: number
                }
    ): Observable<Array<OrderInfoWithOfferInfoDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/order/orders2`;

            return this._httpClient.get<Array<OrderInfoWithOfferInfoDto>>(url, requestOptions);
    }


        startBottlesReservingForOrder(
                    orderId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/order/orders2/${orderId}/startBottlesReserving`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        startTransferOwnershipForOrder(
                    orderId: number
                , 
                queryParams: {
                    sellerOrgUnitId?: number,
                    sellerUserId?: number,
                    walletPassword: string,
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/order/orders2/${orderId}/startTransferOwnership`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        validateBottle(
                    orderId: number,
                    tid: string
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<ValidationResult> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/order/orders/${orderId}/bottles/${tid}/validate`;

            return this._httpClient.post<ValidationResult>(url, requestBody, requestOptions);
    }


        validateOrder(
                    orderId: number
                , 
                queryParams: {
                    tids: Array<string>,
                    userLegalEntityId?: number
                }
    ): Observable<ValidationResult> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/order/orders/${orderId}/validate`;

            return this._httpClient.post<ValidationResult>(url, requestBody, requestOptions);
    }


}

